// IMAGE SLOTS (Sztuki Walki dla Dzieci — Gotowe Treningi, Polish copy of Martial Arts Kids Class Ready)
// Hosted on Higgsfield media (public cloudfront) until the Polish Impultienda store exists. List: productos/martial-arts-kids-pl/landing/recursos.md
const H = 'https://d2ol7oe51mr4n9.cloudfront.net/user_3DMFLKCotDruk7RKAWz1zy5qmH0/';

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code (no AI text): the Polish Gamma Studio cover plus
 * real pages on the iMac, and the bonus photos with their Polish titles typed in. Pure white background.
 */
const IMAC = H + '75d248db-1b56-4ab7-9aee-60fd40e16da8.jpg';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/**
 * Real pages of the Polish Gamma Studio book (9:16), same order as lookInside.captions: p.4, 8, 9, 10, 37, 39.
 * Only pages that passed the page-by-page check of the Polish book (26/10): never p.13, 16, 17, 19, 20, 22, 25, 26, 34, 35 or 40.
 */
export const pageImages: string[] = [
  H + '333df4d1-8cc0-444c-a087-a3eea23f7bee.jpg',
  H + '525ed7e9-7577-406f-920c-e04cc27a8742.jpg',
  H + '14865f9c-3539-4fcb-b2f5-362b1df88995.jpg',
  H + '90bfecbf-4cb7-421d-b511-19b7d11ca2a5.jpg',
  H + '7028309d-6d69-44a7-9384-26c22844437b.jpg',
  H + 'e9b469fb-eb90-43f3-b423-e5572e9223d1.jpg',
];
/** 5 bonus covers (Polish titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  H + '83045937-db7a-4a8e-a309-7c093800ad4d.jpg',
  H + '1d94a872-e666-41fc-a95c-96a1eb78d836.jpg',
  H + '6bd867ee-cc8c-4fb5-926c-0555664ec93f.jpg',
  H + '9b3202df-7679-4eea-93b1-ef60fb26a8fd.jpg',
  H + '9f7aad2b-653e-4c1f-8a17-112131f769f5.jpg',
];
